
export const ExpertInformation = (props:any) => {
    const {uuid,full_name,role} = props;
  return (
    <div className="col-sm-6 px-4">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Uuid:</th>
            <td>{uuid}</td>
          </tr>
          <tr>
            <th scope="row">Full Name:</th>
            <td>{full_name}</td>
          </tr>
          <tr>
            <th scope="row">Role:</th>
            <td>{role}</td>
          </tr>
          </tbody>
      </table>
    </div>
  )
}
